import { Navigo__SideNavbarSubItemControllerIdentifier } from "controllers/identifiers";
import BaseController from "confinus_ui/base_controller";
import SideNavbarSubItemController from "navigo/side_navbar_sub_item_controller";

export default class SideNavbarItemController extends BaseController {
  public static outlets = [Navigo__SideNavbarSubItemControllerIdentifier];
  declare private readonly navigoSideNavbarSubItemOutlets: SideNavbarSubItemController[];
  private get subMenuItemControllers() {
    return this.navigoSideNavbarSubItemOutlets;
  }

  public static targets = ["title", "arrow", "subMenu"];

  public static values = {
    selected: Boolean,
  };

  declare private readonly selectedValue: boolean;

  declare private readonly arrowTarget: HTMLButtonElement;
  declare private readonly hasArrowTarget: boolean;
  declare private readonly titleTarget: HTMLElement;
  declare private readonly hasTitleTarget: boolean;
  declare private readonly subMenuTarget: HTMLElement;
  declare private readonly hasSubMenuTarget: boolean;

  public static classes = [
    "closed",
    "open",
    "entering",
    "leaving",
    "arrowUp",
    "arrowDown",
    "shown",
    "filtered",
  ];
  declare protected readonly closedClasses: string[];
  declare protected readonly openClasses: string[];
  declare protected readonly enteringClasses: string[];
  declare protected readonly leavingClasses: string[];
  declare protected readonly arrowUpClasses: string[];
  declare protected readonly arrowDownClasses: string[];
  declare protected readonly filteredClasses: string[];
  declare protected readonly shownClasses: string[];

  private subMenuOpen = false;

  public connect() {
    super.connect();
    this.subMenuOpen = this.selectedValue == true;
  }

  public buttonClicked() {
    this.subMenuOpen = !this.subMenuOpen;
    this.animateSubMenu();
  }

  public expand() {
    this.subMenuOpen = true;
    this.animateSubMenu();
  }

  public collapse() {
    this.subMenuOpen = false;
    this.animateSubMenu();
  }

  public filterOnSearch(keyword: string): boolean {
    const matchesSubItems =
      this.subMenuItemControllers.filter((item: SideNavbarSubItemController) =>
        item.filterOnSearch(keyword),
      ).length > 0;

    // If anything inside this item matches, expand it
    if (matchesSubItems) {
      this.expand();
    }

    if (!matchesSubItems) {
      const titleMatch = this.toggleOnSearch(
        keyword,
        this.element,
        [this.titleTarget],
        this.shownClasses,
        this.filteredClasses,
      );
      // If the title matches, make sure all sub are shown
      this.subMenuItemControllers.forEach(
        (item: SideNavbarSubItemController) => {
          item.filterOnSearch("");
        },
      );
      return titleMatch;
    } else {
      this.setTargetElementClasses(
        this.element,
        this.filteredClasses,
        this.shownClasses,
      );
    }
    return matchesSubItems;
  }

  private animateSubMenu() {
    if (this.hasSubMenuTarget) {
      this.toggleTargetElementClasses(
        this.subMenuTarget,
        this.subMenuOpen,
        this.closedClasses,
        this.openClasses,
      );
      setTimeout(() => {
        this.toggleTargetElementClasses(
          this.subMenuTarget,
          this.subMenuOpen,
          this.leavingClasses,
          this.enteringClasses,
        );
      }, 100);
    }

    if (this.hasArrowTarget) {
      this.toggleTargetElementClasses(
        this.arrowTarget,
        this.subMenuOpen,
        this.arrowDownClasses,
        this.arrowUpClasses,
      );
    }
  }
}
